














import {Component, Prop, Vue} from 'vue-property-decorator';

type BadgeVariant =
	'primary'
	| 'secondary'
	| 'warning';

@Component({})
export default class Badge extends Vue {
	@Prop({required: false, default: ''}) readonly variant: BadgeVariant;
	@Prop({required: true}) readonly label: string;

	@Prop({default: () => ([])}) readonly classes?: string[];
	@Prop({default: () => ({})}) readonly styles?: CSSStyleDeclaration;
	@Prop({default: null}) readonly element?: string;

	get componentElement(): string {
		if (!this.element) {
			return 'div';
		}

		return this.element;
	}


	get classList(): Array<string | null> {
		return [
			'badge',
			!this.variant.length ? null : `badge--${this.variant}`,
			...(this.classes || [])
		];
	}

	get styleList(): CSSStyleDeclaration | null {
		return this.styles ? {...this.styles} : null;
	}

}
